import React, { useState } from 'react'
import { Tabs, Tab, Box, Button, Typography, IconButton, Paper, InputBase, MenuItem, Menu } from '@mui/material';
import { Search, Upload, Add, FilterList, UploadOutlined } from '@mui/icons-material';
import { Filter } from '../../Svg';
import { styled } from '@mui/material/styles';
import { setOrderFromDate, setOrderSearch, setOrderToDate } from '../../redux/orderSlice';
import { useDispatch } from 'react-redux';
import { fomateDate, formateDate, getDateRange } from '../../utils/fomateDate';

import Calendar from 'react-calendar/dist/cjs/Calendar.js';


const SearchInput = styled(Paper)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    borderRadius: '8px',
    boxShadow: 'none',
    border: `1px solid ${theme.palette.divider}`,
    width: '320px',
    fontFamily: `'Public Sans', sans-serif`,
}));

const ActionButton = styled(Button)(({ theme }) => ({
    textTransform: 'none',
    marginRight: theme.spacing(1),
    fontSize: '0.875rem',
    color: '#512DA8',
    backgroundColor: '#F0F1F3',
    fontSize: '14px',
    fontWeight: '600 !important',
    fontFamily: `'Public Sans', sans-serif`,
    '&:hover': {
        backgroundColor: theme.palette.grey[200],
    },
}));

const status = [
    "NEW", "PROCESSING", "PENDING", "SHIPPED", "DELIVERED", "CANCELLED"
]

const OrderFilter = ({ setAllStatus, selectedTabs }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const dispatch = useDispatch()
    const open = Boolean(anchorEl);
    const [showCalendar, setShowCalendar] = useState(false);
    const [selectedTab, setSelectedTab] = useState(0);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleChange = (event, newValue) => {
        setSelectedTab(newValue);
    };

    const handleClose = (status) => {
        if (status) {
            setAllStatus(status)
        }
        setAnchorEl(null);
    };

    const handleDateRangeChange = (period) => {
        const newDateRange = getDateRange(period);
        dispatch(setOrderFromDate(newDateRange.from))
        dispatch(setOrderToDate(newDateRange.to))
    };

    const handleAll = () => {
        dispatch(setOrderFromDate(''))
        dispatch(setOrderToDate(''))
    }

    const handleCalClick = () => {
        setShowCalendar(prevState => !prevState);
    };

    const handleCalenderData = (e) => {
        dispatch(setOrderFromDate(formateDate(e)));
        dispatch(setOrderToDate(formateDate(e)));
        handleCalClick()
    }

    return (

        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 15 }}>
            <Tabs
                value={selectedTab}
                onChange={handleChange}
                aria-label="customer tabs"
                sx={{
                    color: '#512DA8',
                    backgroundColor: '#fff',
                    width: '37%',
                    height: '40px',
                    minHeight: '40px !important',
                    borderRadius: '8px',
                    border: '1px solid #E0E2E7',
                    lineHeight: '28px',
                    '& .MuiTabs-indicator': {
                        backgroundColor: 'transparent',
                    },
                    '& .MuiButtonBase-root.MuiTab-root': {
                        padding: '0 0px',
                        minWidth: '78px',
                    },
                    '& .MuiTab-root': {
                        fontSize: '14px',
                        textTransform: 'capitalize',
                        color: '#585757',
                        height: '36px !important',
                        minHeight: '36px !important',
                    },
                    '& .Mui-selected': {
                        fontSize: '14px',
                        textTransform: 'capitalize',
                        color: '#512DA8 !important',
                        background: '#F0F1F3',
                        borderRadius: '6px',
                        margin: '4px',
                        height: '32px !important',
                        minHeight: '32px !important',
                        paddingTop: '0px',
                        paddingBottom: '0px',
                    },
                    '& .MuiTabs-flexContainer': {
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-start',
                        gap: 0,
                        padding: 0,
                        margin: 0,
                        height: '100%',
                    },
                }}
            >
                <Tab label="All Date" sx={{
                    color: selectedTab === 0 ? '#FFFFFF' : '#512DA8',
                    borderRadius: '8px',
                }}
                    onClick={handleAll}
                />
                <Tab label="12 Months" onClick={() => handleDateRangeChange("12months")} />
                <Tab label="30 Days" onClick={() => handleDateRangeChange("30days")} />
                <Tab label="7 Days" onClick={() => handleDateRangeChange("7days")} />
                <Tab label="24 Hour" onClick={() => handleDateRangeChange("1day")} />

            </Tabs>


            {/*  <SelectDate /> */}

            <div style={{ display: 'flex', justifyContent: 'space-between', gap: "10px" }}>
                <SearchInput>
                    <IconButton aria-label="search">
                        <Search />
                    </IconButton>
                    <InputBase placeholder="Search…" onChange={(e) => dispatch(setOrderSearch(e.target.value))} />
                </SearchInput>

                <div style={{ position: 'relative' }} >
                    <ActionButton
                        onClick={() => handleCalClick('')}
                        sx={{
                            color: '#667085',
                            border: '1px solid #E0E2E7',
                            background: '#fff',
                            borderRadius: '8px',
                        }}
                    >
                        <Filter /> Select dates
                    </ActionButton>
                    {showCalendar && (
                        <div className="calender">
                            <Calendar onChange={(e) => handleCalenderData(e)} />
                        </div>
                    )}
                </div>
                {selectedTabs === 0 &&
                    <ActionButton
                        onClick={handleClick}
                        sx={{
                            color: '#667085',
                            border: '1px solid #E0E2E7',
                            background: '#fff',
                            borderRadius: '8px',
                        }}
                    >
                        <Filter /> Status
                    </ActionButton>
                }
                <Menu
                    anchorEl={anchorEl}
                    open={open}
                    onClose={() => handleClose('')}
                    MenuListProps={{
                        'aria-labelledby': 'status-button',
                    }}
                >
                    {
                        status?.map((i) => (
                            <MenuItem onClick={() => handleClose(i)}
                                sx={{
                                    borderBottom: '1px solid #E6E1E5',
                                    fontSize: '14px',
                                    color: '#667085',
                                    textTransform: 'capitalize'
                                }}>
                                {i}
                            </MenuItem>
                        ))
                    }


                </Menu>
            </div>

        </div>
    )
}

export default OrderFilter